import { MAX_GIFTS_PER_MONTH } from "@pages/Article/components/ArticleSubshare/constants";

export default function GiftingLimitReached(): React.ReactElement {
  return (
    <p className="font-poppins text-base">
      {`You've already gifted the maximum of ${MAX_GIFTS_PER_MONTH} premium stories. Try again in the next month.`}
    </p>
  );
}
